/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import React from 'react';
import { KeyCodes } from '@msdyn365-commerce-modules/utilities';

export interface ISearchBarProps {
    className: string;
    searchPlaceholderLabel: string;
    onSearch(): void;
    onSearchTextChange(searchText: string): void;
    searchText: string;
}

export class SearchBar extends React.Component<ISearchBarProps> {
    constructor(props: ISearchBarProps) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        const { className, searchPlaceholderLabel } = this.props;
        return (
            <div className={`${className}__search`}>
                <input
                    type='text'
                    className={`${className}__searchBar`}
                    placeholder={searchPlaceholderLabel}
                    onChange={this.onSearchTextChange}
                    onKeyUp={this.handleKeyUp}
                />
                <button className={`${className}__searchButton`} onClick={this.onSearch} title={searchPlaceholderLabel} />
            </div>
        );
    }

    private readonly onSearchTextChange = (ev: React.ChangeEvent<HTMLInputElement>): void => {
        this.props.onSearchTextChange(ev.target.value);
    };

    private readonly onSearch = (): void => {
        this.props.onSearch();
    };

    private readonly handleKeyUp = (event: React.KeyboardEvent): void => {
        if (event.keyCode === KeyCodes.Enter) {
            this.onSearch();
        }
    };
}
